<div class="container">
    <app-loading *ngIf="showLoading"></app-loading>

    <ng-container *ngIf="historyItems && historyItems.length > 0; else elseBlock">
        <h2>{{ 'Title.TitleHistory' | translate }}</h2>
        <div align="center" class="center">
            <button *ngIf="historyItems" (click)="changeUserId()" class="delete-button"><img
                    src="assets/images/recycle.png" title="recycle" alt="recycle"> <span>{{ 'Buttons.deleteHistory' |
                    translate }}</span></button>
            <button *ngIf="historyItems" (click)="updateHistory()" class="refreash-button"><span>{{ 'Buttons.update' |
                    translate }}</span></button>
        </div>

        <div align="center">
            <table *ngFor="let historyItem of historyItems">
                <tr>
                    <td class="text-bold">
                        {{historyItem.Items[0].ProviderName}}
                    </td>
                    <td>

                    </td>
                </tr>
                <ng-container *ngFor="let item of historyItem.Items">
                    <ng-container *ngFor="let itemInputs of item.ItemInputs">
                        <tr *ngIf="itemInputs.InputName != 'Input4'">
                            <td class="text-bold">{{itemInputs.InputName }}</td>
                            <td>{{itemInputs.Value}}</td>
                        </tr>
                    </ng-container>
                </ng-container>
                <tr>
                    <td class="text-bold">{{ 'label.amount' | translate }}</td>
                    <td>{{historyItem.Amount}}</td>
                </tr>
                <tr>
                    <td class="text-bold">{{ 'label.date' | translate }}</td>
                    <td>{{historyItem.CreationDate | date:'dd-MM-yyyy'}}</td>
                </tr>
                <ng-container *ngFor="let item of historyItem.Items">
                    <tr class="text-bold">
                        <td>{{ 'label.state' | translate }}</td>
                        <td>{{getStatus(item.State)}}</td>
                    </tr>
                </ng-container>
                <div class="history-table-buttons">
                    <a class="history-table-button history-table-button-2"
                        *ngIf="historyItem.FormUrl && historyItem.State == '3'"
                        (click)='continuePayment(historyItem.FormUrl)'>{{ 'label.pay' | translate }}</a>
                    <a class="history-table-button" (click)="showMoreInfo(historyItem)">{{ 'label.moreInfo' | translate
                        }}</a>
                    <ng-container *ngFor="let item of historyItem.Items">
                        <a class="history-table-button" *ngIf="historyItem.State =='4'"
                            (click)="getReceipt(item.ItemGUID)">{{ 'label.receipt' | translate }}</a>
                    </ng-container>
                </div>
            </table>
        </div>
    </ng-container>
    <ng-template #elseBlock>
        <div style="min-height: 300px; ">
            <div style="text-align: center; font-size: 100px; color: #6400dc;" ><fa-icon [icon]="emptyIcon"></fa-icon> </div>
            <div style="text-align: center; font-size: 1.2em; font-weight: 800;color: #6400dc;margin-top: 25px;"  [translate]="'Title.historyEmpty'"> </div>
        </div>
    </ng-template>
</div>

<app-modal [(show)]="showModal" [modalHistoryItem]="modalHistoryItem" (closed)="showModal = $event"></app-modal>